/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ObservacaoAlteracaoProdutoAliases {
  FETCH_CONSULTA = 'fetch-consulta',
  FIELD_OBSERVACAO = 'field-observacao',
  FORM_MOTIVO = 'form-motivo',
  PANEL_0 = 'panel-0',
  TEXT_AREA_0 = 'text-area-0',
}
export { ObservacaoAlteracaoProdutoAliases };
